import Image from "$lib/portableText/Image.svelte";
import YouTubeEmbed from "$lib/portableText/YouTubeThumbnailLink.svelte";
import InlineReference from "$lib/portableText/InlineReference.svelte";
import SourceReference from "$lib/portableText/SourceReference.svelte";
import TextHighlighted from "$lib/portableText/TextHighlighted.svelte";
import ChecklistWrapper from "$lib/portableText/ChecklistWrapper.svelte";
import Link from "$lib/portableText/Link.svelte";
import TypeformEmbed from "$lib/portableText/TypeformEmbed.svelte";
import TextColor from "$lib/portableText/TextColor.svelte";
// import UnorderedList from "$lib/portableText/UnorderedList.svelte";
import ColumnLayout from "./ColumnLayout.svelte";
import Table from "./Table.svelte";
import DetailsSummary from "./DetailsSummary.svelte";

export const contentBlockComponents = {
  types: {
    image: Image,
    youtube: YouTubeEmbed,
    productReference: InlineReference,
    articleReference: InlineReference,
    fileReference: InlineReference,
    sourceReference: SourceReference,
    typeformEmbed: TypeformEmbed,
    columns: ColumnLayout,
    table: Table,
    detailsSummary: DetailsSummary,
  },
  marks: { link: Link, highlight: TextHighlighted, color: TextColor },
  list: {
    check: ChecklistWrapper,
    // bullet: UnorderedList,
  },
};
